import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { TicketTable } from "../../UI/Advertising/ticket/TicketTable";

const TicketPanel = () => {
  return (
    <div>
      <PanelHead title="Ticket" />
      <PanelBody content={<TicketTable />} />
    </div>
  );
};

export default React.memo(TicketPanel);
